<template>
  <f7-page>
    <f7-navbar title="Stránka nebola nájdená" back-link="Back"></f7-navbar>
    <f7-block strong class="text-align-center">
      <strong>Ospravedlňujeme sa.</strong>
      <p>Požadovaná stránka nebola nájdená.</p>
    </f7-block>
  </f7-page>
</template>
<script>
  export default {};
</script>